import React, { useEffect, useState } from "react";
import { Breadcrumb, Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import CardHeader from "react-bootstrap/CardHeader";
import BgDashboard from "./images/bg-dashboard.png";
import "./styles/dashboard.css";
import { useAPI } from "../../hooks/useAPI";
import TreatmentTypeChart from "./components/TreatmentTypeChart";
import Loader from "../../components/messages/Loader";
import BusinessSelect from "../../components/form/BusinessSelect";
import { useAuth } from "../../hooks/useAuth";
import TermsModal from "../../components/TermsModal";
import { AuthContext } from "../../providers/AuthContextProvider";
import TranslateTerms from "../../components/TranslateTerms";
import Map from "../../components/Map";
import { PersonModel } from "../../models/PersonModel";
import { PersonType } from "../../types/PersonType";
import { PairingType } from "../../types/PairingType";
import { FormattedMessage } from "react-intl";
import { LANG_COMMON_CLINIC, LANG_COMMON_DASHBOARD, LANG_COMMON_FROM_DATE, LANG_COMMON_OPTIONS, LANG_COMMON_PAIRINGS, LANG_COMMON_SEARCH, LANG_COMMON_TO_DATE } from "../../lang";

const DashboardPage = () => {
    const { api } = useAPI();
    const [stats, setStats] = useState<undefined | any>(undefined);
    const [fromDate, setFromDate] = useState<string>("");
    const [toDate, setToDate] = useState<string>("");
    const [loading, setLoading] = useState(false);
    
    const loadStats = (options: any) => {
        setLoading(true);
        api().get(`/api/treatment-report?${new URLSearchParams({ ...options, cache: (new Date()).getTime(), dateFrom: fromDate, dateTo: toDate }).toString()}`)
            .then((resp) => {
                setStats(resp.data);
                setLoading(false);
            });
    }

    useEffect(() => {
        loadStats({});
    }, []);

    return (
        <>
            {loading && (<Loader fullscreen={true} />)}
            {!loading && stats !== undefined && (
                <div className="bg-pattern" style={{ 'paddingBottom': '2rem' }}>
                    <Container>
                        <Row>
                            <Breadcrumb>
                                <Breadcrumb.Item active>
                                    <FormattedMessage {...LANG_COMMON_DASHBOARD} />
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </Row>
                        <Row>
                            <Col lg={{ offset: 0, span: 8 }}>
                                <div className="bg-dashboard">
                                    <img src={BgDashboard} alt="" />
                                </div>
                                <div className="mt-5 chart">
                                    {stats !== undefined && (<TreatmentTypeChart stats={stats} />)}
                                </div>
                            </Col>
                            <Col lg={{ span: 4 }}>
                                <Card>
                                    <CardHeader>
                                        <Card.Title>
                                            <FormattedMessage
                                                {...LANG_COMMON_OPTIONS}
                                            />
                                        </Card.Title>
                                    </CardHeader>
                                    <Card.Body>
                                        <Form onSubmit={(e) => {
                                            e.preventDefault();
                                            loadStats({});
                                        }}>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>
                                                            <FormattedMessage
                                                                {...LANG_COMMON_FROM_DATE}
                                                            />
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            onChange={(e) => setFromDate(e.target.value)}
                                                            value={fromDate}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-md-6">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>
                                                            <FormattedMessage
                                                                {...LANG_COMMON_TO_DATE}
                                                            />
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            disabled={fromDate === ""}
                                                            min={fromDate}
                                                            onChange={(e) => setToDate(e.target.value)}
                                                            value={toDate}
                                                        />
                                                    </Form.Group>
                                                </div>
                                            </div>
                                            <div className="d-grid gap-2">
                                                <div className="row">
                                                    <div className="col-md-8 offset-2">
                                                        <Button variant="primary" size={'lg'}
                                                            type="submit" className="btn-custom btn-custom-small bg-custom-gradient w-100">
                                                            <FormattedMessage {...LANG_COMMON_SEARCH} />
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </Form>
                                    </Card.Body>
                                </Card>
                                <div className="my-4">
                                    <Card>
                                        <CardHeader>
                                            <Card.Title>
                                                <FormattedMessage
                                                    id="dashboard.header.data"
                                                    defaultMessage="DADOS"
                                                    description="Dashboard - Cabeçalho do quadro de informações com números de doadores, etc..."
                                                />
                                            </Card.Title>
                                        </CardHeader>
                                        <Card.Body>
                                            <div className="row dashboard-stats">
                                                <div className="col-md-6 stats-donors">
                                                    <h4>Tratamentos</h4>
                                                    <h6>{stats.total_tratamentos}</h6>
                                                </div>
                                                <div className="col-md-6 stats-receivers">
                                                    <h4>Média de Idade</h4>
                                                    <h6>{stats.media_idade} <small>anos</small></h6>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            )}
        </>
    );
}

export default DashboardPage;